import React from 'react';
import { useSelector } from 'react-redux';
import { getShowConfirmationPage } from '../../../selectors/tools';
import DTCancelAndRefundOrderItemsThenSendMacroNode from '../NodeGroups/DTCopyTextSendMacro/DTCancelAndRefundOrderItemsThenSendMacroNode/DTCancelAndRefundOrderItemsThenSendMacroNode';

const CancelAndRefundOrderItemsThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTCancelAndRefundOrderItemsThenSendMacroNode
      showConfirmation={showConfirmationPage}
      message={'The items have been refunded.'}
    />
  );
};

export default CancelAndRefundOrderItemsThenSendMacro;
